import IBroker from './IBroker';

export function transformBroker(broker: IBroker): any {
    return {
        aclNumber: broker.aclNumber,
        aggregatorUuid: broker.aggregatorUuid,
        agreeRepresentationsandWarranties: broker.agreeRepresentationsandWarranties,
        australianBusinessNumber: broker.australianBusinessNumber,
        companyName: broker.companyName,
        email: broker.email,
        firstName: broker.firstName,
        hasBeenBankrupted: broker.hasBeenBankrupted,
        hasBeenConvicted: broker.hasBeenConvicted,
        hasIndemnityInsurance: broker.hasIndemnityInsurance,
        landingPage: broker.landingPage,
        lastName: broker.lastName,
        linkedInUrl: broker.linkedInUrl,
        phone: broker.phone,
        postalAddress: broker.postalAddress,
        postcode: broker.postcode,
        registrationSource: broker.registrationSource,
        state: broker.state,
        suburb: broker.suburb,
        type: broker.type,
    };
}
